import { render, staticRenderFns } from "./DeviceAccounts.vue?vue&type=template&id=63887745&scoped=true"
import script from "./DeviceAccounts.vue?vue&type=script&lang=js"
export * from "./DeviceAccounts.vue?vue&type=script&lang=js"
import style0 from "./DeviceAccounts.vue?vue&type=style&index=0&id=63887745&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63887745",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63887745')) {
      api.createRecord('63887745', component.options)
    } else {
      api.reload('63887745', component.options)
    }
    module.hot.accept("./DeviceAccounts.vue?vue&type=template&id=63887745&scoped=true", function () {
      api.rerender('63887745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAccounts/DeviceAccounts.vue"
export default component.exports